import { Grid, Menu, MenuItem } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { dateTimeFormat } from '../../util/DateUtil';
import { ADMIN, COORDENADOR, PROFESSOR } from '../Usuario/Perfil';
import BadgeQuantNaoLidas from './MensagemTable/BadgeQuantNaoLidas';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import UserIcon from '../../shared/assets/img/User.png';
import Divider from '@mui/material/Divider';
import Button from '../UI/Button';
import { setQuantNaoLidas } from './SalaParticipante/actions/actions';

const useStyles = makeStyles({
    fotoComponent: {
        // width: '80px',
        maxHeight: '80px',
        borderRadius: '100%',
        marginRight: '20px'
    },
    mensUserComp: {
        cursor: 'pointer',
    }
})

const MensagemUser = ({ sp, getNameRoom }) => {
    const classes = useStyles();
    const user = useSelector(state => state.usuario);
    const [anchorTableEl, setAnchorTableEl] = useState(null);
    const [salaSelected, setSalaSelected] = useState(null);
    const history = useNavigate();
    const dispatch = useDispatch();
    const quantNaoLidas = useSelector(state => state.quantNaoLidas);

    const handleMenuTableClick = (event, sala) => {
        setAnchorTableEl(event.currentTarget);
        setSalaSelected(sala);
    };

    const handleMenuTableClose = () => {
        setAnchorTableEl(null);
    };

    const handleSalaMensagem = () => {
        if(sp.quantNaoLidas > 0){
            dispatch(setQuantNaoLidas(quantNaoLidas - sp.quantNaoLidas));
        }
        history('/sala-mensagem', {
            state: {
                salaParticipante: sp,
                nameRoom: getNameRoom(sp)
            }
        })
    }

    return (
        <Grid container spacing={3} >
            <Grid spacing={2} size={12}>
                <Grid
                    container
                    direction='row'
                    alignItems='center'
                >
                    <Grid size={2}>
                        {sp.sala.isGroup ?
                            <img
                                src={UserIcon}
                                alt=''
                                className={classes.fotoComponent}
                            /> :
                            <>
                                {sp.usuario.fileName ?
                                    <img
                                        className={classes.fotoComponent}
                                        src={sp.usuario.fotoUrl}
                                        alt=''
                                    /> :
                                    <img
                                        src={UserIcon}
                                        alt=''
                                        className={classes.fotoComponent}
                                    />
                                }
                            </>
                        }
                    </Grid>
                    <Grid className={classes.mensUserComp} onClick={handleSalaMensagem} size={3}>
                        <Grid container>
                            <Grid size={12}>
                                {sp.sala.isGroup ?
                                    'Grupo: ' + sp.sala.descricao :
                                    <>
                                        {sp.usuario.nome}
                                    </>
                                }

                                <BadgeQuantNaoLidas quantNaoLidas={sp.quantNaoLidas} />
                            </Grid>
                            <Grid size={12}>
                                {dateTimeFormat(sp.sala.dataHoraUtlimaMensagem)}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={2}>
                        <Button
                            onClick={handleSalaMensagem}
                            color='secondary'
                        >
                            Ir para sala
                        </Button>
                    </Grid>
                    <Grid size={2}>
                        {sp.sala.isGroup &&
                            user && user.perfil && (user.perfil === ADMIN ||
                                user.perfil === COORDENADOR ||
                                user.perfil === PROFESSOR)
                            ?
                            <>
                                <MoreVertIcon
                                    id={"menu" + sp.sala.codigo}
                                    fontSize='small'
                                    className={classes.mensUserComp}
                                    onClick={(event) => handleMenuTableClick(event, sp.sala)}
                                    color="secondary"

                                />
                                <Menu
                                    id={"simple-menu" + sp.sala.codigo}
                                    anchorEl={anchorTableEl}
                                    keepMounted
                                    open={Boolean(anchorTableEl)}
                                    onClose={handleMenuTableClose}
                                >
                                    <MenuItem
                                        component={Link}
                                        to={{
                                            pathname: '/group-form',

                                        }}
                                        state={{
                                            sala: salaSelected
                                        }}
                                    >
                                        Atualizar Grupo
                                    </MenuItem>
                                    <MenuItem
                                        component={Link}
                                        to={{
                                            pathname: '/group-list-participants',

                                        }}
                                        state={{
                                            sala: salaSelected
                                        }}
                                    >
                                        Lista Participantes
                                    </MenuItem>
                                </Menu>
                            </>
                            : ''}
                    </Grid>

                </Grid>
            </Grid>
            <Grid size={12}>
                <Divider />
            </Grid>
        </Grid>
    );
}

export default MensagemUser;